@if (isLoggedIn$ | async) {
    <app-notifications></app-notifications>

    <ion-menu-toggle>
        <ion-button>
            <ion-icon slot="icon-only" name="menu"></ion-icon>
        </ion-button>
    </ion-menu-toggle>    
}